import Field from 'Component/Field';
import FIELD_TYPE from 'Component/Field/Field.config';
import {
    ProductConfigurableAttributeDropdown as SourceProductConfigurableAttributeDropdown
} from 'SourceComponent/ProductConfigurableAttributeDropdown/ProductConfigurableAttributeDropdown.component';

import './ProductConfigurableAttributeDropdown.override.style';

/** @namespace Elganso/Component/ProductConfigurableAttributeDropdown/Component */
export class ProductConfigurableAttributeDropdownComponent extends SourceProductConfigurableAttributeDropdown {
    render() {
        const {
            selectOptions,
            selectValue,
            selectName,
            selectLabel,
            onChange,
            handleShakeAnimationEnd,
            isUnselected
        } = this.props;

        let opcionSeleccionada = selectValue;

        if (selectValue === '' && selectName === 'precio_tarjeta_regalo') {
            if (selectOptions[0].isAvailable) {
                opcionSeleccionada = selectOptions[0].value;
            }
        }

        return (
            <Field
              type={ FIELD_TYPE.select }
              attr={ {
                  id: selectName,
                  name: selectName,
                  // defaultValue: (opcion_seleccionada)? parseInt(opcion_seleccionada) : selectValue,
                  // defaultValue: selectOptions[0].value,
                  defaultValue: opcionSeleccionada,
                  selectPlaceholder: __('Choose %s...', selectLabel.toLowerCase()),
                  onAnimationEnd: handleShakeAnimationEnd
              } }
              events={ {
                  onChange
              } }
              mix={ { block: 'ProductConfigurableAttributeDropdown', mods: { isUnselected } } }
              options={ selectOptions }
              changeValueOnDoubleClick
            />
        );
    }
}

export default ProductConfigurableAttributeDropdownComponent;
